import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import endpoints, { getBackendUrl } from '../../endpoints';
import axios from 'axios';
import {storage} from '../../storage';
import { useSelector, useDispatch } from 'react-redux'
import PortfolioTable from './tables/PortfolioTable'
import EditPortfolioModal from './modals/EditPortfolioModal'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import AddBoxIcon from '@mui/icons-material/AddBoxRounded';
import Confirmation from './modals/Confirmation';
import Warning from './modals/Warning';
import AiRateModal from './modals/AiRateModal';
import withAlert from '../../hoc/withAlerts'
import { setHeader } from '../../redux/headerSlice'
import { ReactSpreadsheetImport } from "react-spreadsheet-import";
import UploadFileIcon from '@mui/icons-material/UploadFileRounded';
import Loading from '../pages/parts/Loading'
import ReplayIcon from '@mui/icons-material/ReplayRounded';
import TroubleshootIcon from '@mui/icons-material/TroubleshootRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Grow from '@mui/material/Grow';

function Portfolio(props) {
    const [list, setList] = useState(null)
    const [pagination, setPagination] = useState({
        page: 1,
        perpage: 10,
        total: 0
    })
    const [perpage, setPerpage] = useState(storage.autoreply.perpage);
    const [dialogData, setDialogData] = useState(null)
    const [deleteItem, setDeleteItem] = useState()
    const [warningText, setWarningText] = useState()
    const [importOpen, setImportOpen] = useState()
    const [loading, setLoading] = useState(false)
    const [aiRate, setAiRate] = useState(null)
    const [aiRateText, setAiRateText] = useState('')

    const dispatch = useDispatch()

    const token = useSelector((state) => state.auth.token)

    const getList = async (page, clearScroll = false) => {
        storage.portfolio.perpage = perpage;
        
        let uri = ''
        if (aiRateText) {
            uri = getBackendUrl(endpoints.portfolio_ai_rate, token)
        } else {
            uri = getBackendUrl(endpoints.portfolio, token)
        }
        
        const params = {}
        if (page) {
            params.page = page
        }
        if (perpage) {
            params.perpage = perpage
        }
        
        if (aiRateText) {
            params.query = aiRateText
        }
        
        setLoading(true)
        try {
            let res = await axios.get(uri, {params: params})
            setList(res.data.items)
            setPagination({
                page: res.data.page + 1,
                perpage: res.data.perpage,
                total: res.data.total,
                pages: Math.ceil(res.data.total / res.data.perpage)
            })
            if (clearScroll) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }            
        } catch (e) {
            setList([])
            showAlertError('Unknown Error - get list')
        }
        setLoading(false)
    }
    
    const handlePaginate = (value) => {        
        getList(value, true)
    }

    const refreshHandler = async () => {
        await getList(pagination.page - 1)
    }

    const handleChangePerpage = (value) => {
        setPerpage(value)
    }

    const saveHandle = (data) => {
        setDialogData(null)
        getList()
    }
    
    const deleteHandle = async (response) => {
        if (response) {
            let uri = getBackendUrl(endpoints.portfolio_delete, token).replace('{id}', deleteItem.id)
            try {
                await axios.delete(uri)
                await getList()
                showAlertSuccess('Item deleted successfully!')
            } catch (e) {
                showAlertError('Unknown Error - delete Item')
            }
        }
        setDeleteItem(null)
    }
    
    const importSubmitHandle = async (data, file) => {
        setLoading(true)
        let uri = getBackendUrl(endpoints.portfolio_import, token)
        try {
            await axios.post(uri, {
                data: JSON.stringify(data.validData)
            })
            await getList()
            showAlertSuccess('The import was successful!')
        } catch (e) {
            console.log(e)
            showAlertError('Unknown Error - Import Items')
        }
        setLoading(false)
    }
    
    useEffect(() => {
        getList()
    }, [perpage, aiRateText])

    useEffect(() => {
        getList();
        if (!props.embedded) {
            dispatch(setHeader({
                title: 'Portfolio'
            }))
        }
    }, []);

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Grow in={list ? true : false}>
            <Stack sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '20px' }}>
                {aiRateText ?
                <Alert 
                    sx={{mb:2}}
                    severity="warning"
                    icon={<TroubleshootIcon />}
                    action={
                        <IconButton
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setAiRateText(null);
                            }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    <AlertTitle>AI Rate Query</AlertTitle>
                    {aiRateText}
                </Alert>
                : null}
                <PortfolioTable 
                    items={list}
                    pagination={pagination}
                    handlePaginate={handlePaginate}
                    handleChangePerpage={handleChangePerpage}
                    onRefresh={refreshHandler}
                    btnEditHandle={(item) => {setDialogData(item)}}
                    btnDeleteHandle={(item) => {setDeleteItem(item)}}
                    withAiRate={aiRateText ? true : false}
                    headerContent={
                        (<Stack direction="row" spacing={2} sx={{flexGrow:1}}>
                            <IconButton 
                                size="small"
                                sx={{mb:-0.5}} 
                                onClick={() => {getList()}}
                            >
                                <ReplayIcon />
                            </IconButton>
                            <Stack sx={{flexGrow:1}}/>
                            <Button
                                variant="contained"
                                startIcon={<TroubleshootIcon />}
                                color="secondary"
                                onClick={() => {setAiRate(aiRateText || '')}}
                            >
                                AI Rate
                            </Button>
                            <Button 
                                variant="contained" 
                                startIcon={<UploadFileIcon />} 
                                color="success" 
                                onClick={() => {setImportOpen(true)}}
                            >
                                Import
                            </Button>
                            <Button 
                                variant="contained" 
                                startIcon={<AddBoxIcon />} 
                                onClick={() => {setDialogData({})}}
                            >
                                Add Item
                            </Button>
                        </Stack>)
                    }
                />
                <EditPortfolioModal 
                    dialogData={dialogData}
                    onClose={ () => {setDialogData(null)} }
                    onSave={saveHandle}
                />
                <Confirmation data={deleteItem} onResponse={deleteHandle} />
                <Warning text={warningText} onClose={() => {setWarningText(null)}} />
                <ReactSpreadsheetImport 
                    isOpen={importOpen} 
                    onClose={() => {setImportOpen(false)}} 
                    onSubmit={importSubmitHandle}
                    fields={[
                        {label: 'Name', key: 'name', fieldType: {type: "input"}, validations: [{rule: 'required', errorMessage: 'Name is required'}] },
                        {label: 'URL', key: 'url', fieldType: {type: "input"}, validations: [{rule: 'required', errorMessage: 'Url is required'}] },
                        {label: 'Description', key: 'description', fieldType: {type: "input"}, validations: [{rule: 'required', errorMessage: 'Description is required'}] },
                    ]}
                />
                <AiRateModal 
                    data={aiRate} 
                    onClose={() => {setAiRate(null)}} 
                    onApply={(text) => {setAiRateText(text); setAiRate(null)}}
                />
                {loading ? <Loading/> : null}
            </Stack>
        </Grow>
    );
}

export default withAlert(Portfolio)